import { icons } from "lucide-react";
import { useState } from "react";

import { cn } from "~/utils";

import { Icon } from "./icon";

interface GitButtonProps {
  icon: keyof typeof icons;
  size?: number;
  className?: string;
  title: string;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
}

export function GitButton({
  icon,
  size = 16,
  className,
  title,
  onClick,
  href,
  target,
  rel,
}: GitButtonProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  const commonProps = {
    onMouseEnter: () => setShowTooltip(true),
    onMouseLeave: () => setShowTooltip(false),
    onFocus: () => setShowTooltip(true),
    onBlur: () => setShowTooltip(false),
    className: cn(
      "flex items-center justify-center rounded p-1 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-600",
      className,
    ),
    "aria-label": title,
  };

  return (
    <div className="relative">
      {href ? (
        <a href={href} target={target} rel={rel} {...commonProps}>
          <Icon name={icon} size={size} />
        </a>
      ) : (
        <button type="button" onClick={onClick} {...commonProps}>
          <Icon name={icon} size={size} />
        </button>
      )}
      {showTooltip ? <Tooltip text={title} /> : null}
    </div>
  );
}

interface TooltipProps {
  text: string;
}

const Tooltip = ({ text }: TooltipProps) => (
  <div className="absolute bottom-full left-1/2 mb-1 -translate-x-1/2 transform whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white shadow-lg">
    {text}
  </div>
);
